export function focusElement(element, delay = 0): Promise<void> {
  return new Promise((resolve) => {
    // We need to put the `element.focus()` call on top of the stack to make sure IE executes the focus after everything else. This can be done with `setTimeout`.
    setTimeout(() => {
      element.focus();
      resolve();
    }, delay);
  });
}

export function getFocusableElementList() {
  return 'a[href], area[href], input:not([disabled]), input:not([hidden]), select:not([disabled]), select:not([hidden]), textarea:not([disabled]), textarea:not([hidden]), button:not([disabled]), [tabindex="0"]';
}

export function find(items, fn) {
  // Use default find if supported
  if (Array.prototype.find) {
    return items.find(fn);
  }
  // `find` method is not defined on `Array`, so we implement it
  let i = 0;
  let found = null;
  while (!found && i < items.length) {
    found = fn(items[i]) ? items[i] : null;
    i += 1;
  }
  return found;
}

// Use this function to generate an ID.
// For example, this will ensure that each 'som-radio-button' components will have a unique ID automatically.
let lastId = 0;
export function generateId(prefix: string = 'id') {
  lastId += 1;
  return `${prefix}${lastId}`;
}

export function whichTransitionEvent() {
  const el = document.createElement('fakeelement');

  const transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
  };

  const transitionKeys = Object.keys(transitions);
  let found = false;
  let i = 0;
  while (!found && i < transitionKeys.length) {
    const t = transitionKeys[i];
    if (el.style[t] !== undefined) {
      found = true;
    } else {
      i += 1;
    }
  }

  if (found) {
    const t = transitionKeys[i];
    return transitions[t];
  }

  return null;
}

export function whichAnimationEvent() {
  const el = document.createElement('fakeelement');

  const animations = {
    animation: 'animationend',
    OAnimation: 'oAnimationEnd',
    MozAnimation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
  };

  const animationKeys = Object.keys(animations);
  let found = false;
  let i = 0;
  while (!found && i < animationKeys.length) {
    const t = animationKeys[i];
    if (el.style[t] !== undefined) {
      found = true;
    } else {
      i += 1;
    }
  }

  if (found) {
    const t = animationKeys[i];
    return animations[t];
  }

  return null;
}

export function waitForCSSTransitionToFinish(elem: HTMLElement, callback: Function) {
  // Listen for a transition animation animation
  const transitionEvent = whichTransitionEvent();
  let onTransitionCompletedCb;
  const onTransitionCompleted = (evt) => {
    // Make sure to wait for the proper transition event
    if (evt.target === elem) {
      elem.removeEventListener(transitionEvent, onTransitionCompletedCb);
      callback();
    }
  };
  onTransitionCompletedCb = onTransitionCompleted.bind(this);
  if (transitionEvent) {
    elem.addEventListener(transitionEvent, onTransitionCompletedCb);
  }
}

export function runAfterNextFrameRender(callback: Function) {
  requestAnimationFrame(() => {
    setTimeout(() => {
      callback();
    }, 0);
  });
}

// Returns true of an element is a child of another element; false otherwise
export function isDescendant(parent, child) {
  let node = child.parentNode;
  while (node !== null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

/**
 * 
 * @returns Returns JSX 
 */
export function getRequiredInd(h, required, requiredInd) {
  let _requiredInd;

  if (required && requiredInd === 'required') {
    _requiredInd = <span class="required-indicator" aria-hidden="true"> *</span>
  } else if ((!required && !requiredInd)|| (!required && requiredInd === 'optional')) {
    _requiredInd = <span class="text-optional" aria-hidden="true"> Optional</span>
  } 
  return _requiredInd;
}

export function isInError(error) {
  if (typeof error !== 'string') return false;

  return (error !== null && error.length > 0);
}